import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import './assets/Layout.css';
import { Container } from '@material-ui/core'


// ページ定義
import { RouteWithLayout } from './components';
import { Main as MainLayout } from './layouts';
import { Entry as EntryLayout } from './layouts';
import { Member, Invitation, Notice, Trade, Profile, Acquirer, Merchant, Shop, Terminal, Account, Entry, SalesPromotion, TermsOfService, NotFound } from './views';
import { PayOffList, ConfirmPayment, BankPayment, CreditCardPayment, FeeList } from './views/Adjustment';
import { PointManagement, PointAggregate } from './views/Point';
import { FeeManagement } from './views/Fee';

export default () => (
    <div>
        <CssBaseline />

        <Switch>
            <RouteWithLayout layout={MainLayout} path="/notice" component={Notice} />
            <RouteWithLayout layout={MainLayout} path="/trade" component={Trade} />
            <RouteWithLayout layout={MainLayout} path="/adjustment/download" component={PayOffList} />
            <RouteWithLayout layout={MainLayout} path="/adjustment/confirm" component={ConfirmPayment} />
            {/*<RouteWithLayout layout={MainLayout} path="/adjustment/financial" component={Financial} />*/}
            <RouteWithLayout layout={MainLayout} path="/adjustment/bank" component={BankPayment} />
            <RouteWithLayout layout={MainLayout} path="/adjustment/credit" component={CreditCardPayment} />
            <RouteWithLayout layout={MainLayout} path="/adjustment/feeList" component={FeeList} />
            <RouteWithLayout layout={MainLayout} path="/profile" component={Profile} />
            <RouteWithLayout layout={MainLayout} path="/administration/acquirer" component={Acquirer} />
            <RouteWithLayout layout={MainLayout} path="/administration/merchant" component={Merchant} />
            <RouteWithLayout layout={MainLayout} path="/administration/shop" component={Shop} />
            <RouteWithLayout layout={MainLayout} path="/administration/terminal" component={Terminal} />
            <RouteWithLayout layout={MainLayout} path="/administration/pointManagement" component={PointManagement} />
            <RouteWithLayout layout={MainLayout} path="/administration/pointAggregate" component={PointAggregate} />
            <RouteWithLayout layout={MainLayout} path="/administration/feeManagement" component={FeeManagement} />
            <RouteWithLayout layout={MainLayout} path="/administration/account" component={Account} />
            <RouteWithLayout layout={MainLayout} path="/administration/salesPromotion" component={SalesPromotion} />
            <RouteWithLayout layout={MainLayout} path="/other/termsOfService" component={TermsOfService} />
            <RouteWithLayout layout={EntryLayout} path="/entry" component={Entry} />
            <Redirect to="/notice" />
        </Switch>
    </div>
);
